import { Shield, CheckCircle, AlertTriangle, XCircle } from "lucide-react";

const STATUS_CONFIG = {
  online: { color: "#34C759", icon: CheckCircle, label: "ONLINE" },
  degraded: { color: "#FFCC00", icon: AlertTriangle, label: "DEGRADED" },
  offline: { color: "#FF3B30", icon: XCircle, label: "OFFLINE" },
};

export function SystemHealth({ health }) {
  if (!health || health.length === 0) return null;

  const onlineCount = health.filter(h => h.status === "online").length;
  const avgUptime = (health.reduce((s, h) => s + h.uptime_pct, 0) / health.length).toFixed(2);

  return (
    <div data-testid="system-health" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <div className="panel-header">
        <span className="panel-title">
          <Shield size={10} strokeWidth={1.5} style={{ display: "inline", marginRight: 6 }} />
          SALUD DEL SISTEMA
        </span>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <span className="font-mono" style={{ fontSize: 9, color: "#34C759" }}>
            {onlineCount}/{health.length}
          </span>
          <span className="font-mono" style={{ fontSize: 9, color: "#71717a" }}>
            UPTIME {avgUptime}%
          </span>
        </div>
      </div>

      <div className="panel-body">
        {health.map((service, i) => {
          const config = STATUS_CONFIG[service.status] || STATUS_CONFIG.online;
          const Icon = config.icon;

          return (
            <div key={service.id || i} data-testid={`health-service-${i}`} style={{
              display: "flex", alignItems: "center", gap: 8,
              padding: "6px 0",
              borderBottom: "1px solid rgba(255,255,255,0.04)"
            }}>
              <Icon size={11} strokeWidth={1.5} style={{ color: config.color, flexShrink: 0 }} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <span className="font-mono" style={{ fontSize: 10, color: "#d4d4d8" }}>
                    {service.service}
                  </span>
                  <span className="font-mono" style={{ fontSize: 9, color: "#52525b" }}>
                    {service.latency_ms}ms
                  </span>
                </div>
                <div className="health-bar" style={{ marginTop: 3 }}>
                  <div
                    className="health-fill"
                    style={{
                      width: `${service.uptime_pct}%`,
                      background: config.color,
                    }}
                  />
                </div>
              </div>
              <span className="font-mono" style={{ fontSize: 8, color: config.color, flexShrink: 0, letterSpacing: "0.05em" }}>
                {service.uptime_pct}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
